<template>
  <v-container>
    <v-layout
      align-space-between
      justify-space-between
      column
      fill-height
    >
      <v-flex>
        <h3>{{ strings.notifications }}</h3>
      </v-flex>
    </v-layout>
    <v-layout
      align-space-between
      justify-space-between
      column
      fill-height
    >
      <v-flex
        v-for="(notification, index) in notifications"
        :key="index"
      >
        <NotificationCard
          :notification="notification"
          @nav="nav(notification)"
          @remove="remove(notification)"
        />
      </v-flex>
      <v-flex class="none-outstanding">
        <v-btn
          color="primary"
          class="btn_return"
          dark
          @click="onGoToGroups"
        >
          {{ strings.returnToGroups }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import NotificationCard from "../components/NotificationCard";
export default {
  name: "Notifcations",
  components: {
    NotificationCard
  },
  computed: {
    ...mapGetters("notifications", {
      notifications: "notifications"
    }),
    ...mapGetters("page", ["strings"])
  },
  methods: {
    remove(note) {
      this.$store.commit("notifications/removeNotifications", note);
    },
    async nav(note) {
      await this.$store.dispatch("group/GetGroupsForTechnician");
      await this.$store.dispatch("poi/GetPoisByGroups", note.group);
      this.$store.commit("group/setActiveGroup", note.group);
      this.$store.commit("poi/setActiveGroupPoi", note.poiId);
      this.$router.push({ name: "dataDetail", params: { id: note.poiId } }).catch(() => {});
    },
    onGoToGroups() {
      this.$router.push({ name: "group" }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.btn_return {
  color: black !important;
}
</style>
